exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "iframe {\r\n    border: 0; \r\n    padding: 0; \r\n    margin: 0; \r\n    display: block; \r\n    width: 100%;\r\n}\r\n\r\n@media screen and (min-width: 150px) and (max-width: 550px) {\r\n    .card__detail {\r\n        display: block;\r\n    }\r\n    .card__detail>.detail__item {\r\n        margin-left: 0 !important;\r\n    }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/credit-card-iframe/credit-card-iframe.component.css
// module id = ../../../../../src/app/component/credit-card-iframe/credit-card-iframe.component.css
// module chunks = main